import React from "react";
import { faCookieBite } from "@fortawesome/pro-solid-svg-icons";
import { openPrivacyCenter } from "@singlestore/analytics";
import { box } from "@singlestore/fusion/components/layout";

import { Button } from "components/Button/Button";
import { FaIcon } from "components/FaIcon/FaIcon";

export function KetchPrivacyCenter() {
    return (
        <Button
            size="md"
            aria-label="Cookie consent settings"
            className={box({
                position: "fixed",
                bottom: "0",
                left: "0",
                m: "1x",
                px: "1x",
                py: "0-5x",
            })}
            variation="secondary"
            onClick={openPrivacyCenter}
        >
            <FaIcon icon={faCookieBite} color="low-contrast" />
        </Button>
    );
}
